import script from "./AddressReviewTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressReviewTable.vue?vue&type=script&setup=true&lang=js"

import "./AddressReviewTable.vue?vue&type=style&index=0&id=80f4d38a&lang=scss"

const __exports__ = script;

export default __exports__